// Barcodes.vue

<template>
  <div class="row">
    <div class="col-xl-12">
      <!-- begin: Single Modal -->
      <router-view />
      <!-- end: Single Modal -->

      <div
        v-show="$route.path == '/Report/Barcodes'"
        class="kt-portlet kt-portlet--mobile"
      >
        <div class="kt-portlet__head kt-portlet__head--lg">
          <div class="kt-portlet__head-label">
            <span class="kt-portlet__head-icon">
              <i class="fa fa-store"></i>
            </span>
            <h3 class="kt-portlet__head-title">
              {{ this.$route.meta.breadcrumb }}
            </h3>
          </div>
        </div>
        <div class="kt-portlet__body">
          <!-- begin: Search Form -->
          <form class="kt-form" ref="form" @submit.prevent="formSubmit($event)">
            <div class="row">
              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group mb-3">
                  <label class="mb-1">BARCODE:</label>
                  <input
                    v-model="reBBarcode"
                    type="text"
                    class="form-control"
                    placeholder="กรุณาระบุรหัส BARCODE (มีหลายรหัสให้คั่นด้วย , เช่น 12345,54321)"
                  />
                </div>
              </div>

              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group mb-3">
                  <label class="mb-1">รหัสทรัพย์สิน(เบียร์สด):</label>
                  <treeselect
                    v-model="reBDepartmentMaterialCode"
                    :multiple="true"
                    :load-options="LoadreBDepartmentMaterialCodeOptions"
                    :async="true"
                    v-on:select="ClearAfterselect"
                    searchPromptText="กรุณาพิมพ์คำที่ต้องการค้นหา"
                    placeholder="กรุณาเลือก"
                    :cacheOptions="false"
                  />
                </div>
              </div>

              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group mb-3">
                  <label class="mb-1">สถานะ:
                     <input type="checkbox" v-model="MbIsShowCancel" v-bind:value="false" 
                      v-on:click="clickcheckbox()"
                      > แสดงข้อมูลสถานะยกเลิก
                  </label>
                  <treeselect
                    :disabled = "MbBarcodeStautsDisabled"
                    v-model="reBBarcodeStatusCode"
                    :multiple="true"
                    :options="reBBarcodeStatusCodeOptions"
                    :clear-on-select="true"
                    placeholder="กรุณาเลือก"
                  />
                </div>
              </div>

              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group mb-3">
                  <label class="mb-1">ขนส่ง:</label>
                  <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control m-select2'"
                    :id="'reBTransitId'"
                    :name="'reBTransitId'"
                    :select2-options="reBTransitIdOptions"
                    v-model="reBTransitId"
                  ></select2>
                </div>
              </div>

              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                  <div class="form-group mb-3">
                      <label class="mb-1">จำนวนวันคงค้าง:</label>
                      <input v-model="reBOnHoldDays"
                             type="number"
                             class="form-control"
                             placeholder="กรุณาระบุจำนวนวันคงค้าง" />
                  </div>
              </div>

              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"
                   v-if="showDDLAgentName">
                  
                  <div class="form-group mb-3">
                      <label class="mb-1">ชื่อตัวแทนจำหน่าย:</label>
                      <treeselect v-model="reBHostAgentCode"
                                  :multiple="true"
                                  :options="reBHostAgentCodeOptions"
                                  :clear-on-select="true"
                                  placeholder="กรุณาเลือกผู้ดูแลร้านค้า(ตัวแทน)" />
                  </div>
              </div>

               <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                  <div class="form-group">
                    <label class="label">ผู้ดำเนินการ:</label>
                    <treeselect
                      v-model="UsersId"
                      :multiple="true"
                      :load-options="LoadUsersIdOptions"
                      :async="true"
                      v-on:open="reLoadUsersIdOptions"
                      v-on:select="ClearAfterselect"
                      placeholder="กรุณาเลือก"
                      :cacheOptions="true"
                      ref="UsersId"
                    />
                  </div>
                </div>

              <!-- CR 02/09/2026 — filter "สถานะใช้งาน" -->
              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3" v-if="showActiveStatusFilter">
                <div class="form-group">
                  <label class="label">
                    สถานะใช้งาน:
                    <a
                      href="#"
                      class="ml-1"
                      ref="ActiveStatusInfo"
                      data-toggle="popover"
                      data-trigger="focus"
                      data-placement="bottom"
                      data-html="true"
                      :data-content="ActiveStatusInfoText"
                      @click.prevent
                    ><i class="fa fa-info-circle"></i></a>
                  </label>
                  <treeselect
                    id="ActiveStatus"
                    v-model="ActiveStatus"
                    :options="ActiveStatusOptions"
                    placeholder="กรุณาเลือก"
                    ref="ActiveStatus"
                  />
                </div>
              </div>

              <!-- CR 02/09/2026 ข้อ 4 — filter "สถานะทรัพย์สินเช่า" (เห็นเฉพาะผู้ดูแลระบบ) -->
              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3" v-if="this.$root.canShow(['super_admin'])">
                <div class="form-group">
                  <label class="label">สถานะทรัพย์สินเช่า:</label>
                  <treeselect
                    id="IsLeasedAssets"
                    v-model="IsLeasedAssets"
                    :options="LeasedAssetsOptions"
                    placeholder="กรุณาเลือก"
                    ref="IsLeasedAssets"
                  />
                </div>
              </div>

              <!--Begin : Collap ค้นหาสินค้า-->
              <div class="col-xl-12 col-lg-12 col-md-12 .col-sm-12 col-xs-12 mt-3">
                <Collapsible class="product-collapsible">
                  <div slot="trigger">
                    <div class="customTrigger">
                      <div class="kt-portlet__head-label">
                        <h5 class="kt-portlet__head-title text-primary">
                          <i class="la la-minus-square"></i> ค้นหาสินค้า
                        </h5>
                      </div>
                    </div>
                  </div>

                  <div slot="closedTrigger">
                    <div class="customTrigger">
                      <div class="kt-portlet__head-label">
                        <h5 class="kt-portlet__head-title text-primary">
                          <i class="la la-plus-square"></i> ค้นหาสินค้า
                        </h5>
                      </div>
                    </div>
                  </div>

                  <div id="product">
                    <div class="row">
                      <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                        <div class="form-group mb-3">
                          <label class="mb-1">ประเภทสินค้า:</label>
                          <treeselect
                            v-model="reBProductTypeId"
                            :multiple="true"
                            :options="reBProductTypeIdOptions"
                            :clear-on-select="true"
                            placeholder="กรุณาเลือก"
                          />
                        </div>
                      </div>

                      <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                        <div class="form-group mb-3">
                          <label class="mb-1">ชื่อสินค้า:</label>
                          <treeselect
                            v-model="reBAssetCode"
                            :multiple="true"
                            :options="reBAssetCodeOptions"
                            :clear-on-select="true"
                            placeholder="กรุณาเลือก"
                          />
                        </div>
                      </div>

                      <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                        <div class="form-group mb-3">
                          <label class="mb-1">แบรนด์สินค้า:</label>
                          <treeselect
                            v-model="reBBrandId"
                            :multiple="true"
                            :options="reBBrandIdOptions"
                            v-on:select="BrandIdClearAfterSelect"
                            v-on:deselect="BrandIdClearAfterDeSelect"
                            :clear-on-select="true"
                            placeholder="กรุณาเลือก"
                          />
                        </div>
                      </div>

                      <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                        <div class="form-group mb-3">
                          <label class="mb-1">ชื่อแบรนด์สินค้า:</label>
                          <treeselect 
                            id="ProductIdBrand"
                            v-model="ProductIdBrand"
                            :multiple="true"
                            :options="filteredProductIdBrandOptions"
                            placeholder="กรุณาเลือก"
                            ref="ProductIdBrand"
                          />
                        </div>
                      </div>

                      <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                        <div class="form-group mb-3">
                          <label class="mb-1">ปี(สินค้า):</label>
                          <treeselect
                            v-model="BarcodeYear"
                            :multiple="true"
                            :load-options="LoadBarcodeYearOptions"
                            v-on:open="reLoadBarcodeYearOptions"
                            :async="true"
                            v-on:select="ClearAfterselect"
                            searchPromptText="กรุณาพิมพ์คำที่ต้องการค้นหา"
                            placeholder="กรุณาเลือก"
                            :cacheOptions="true"
                            ref="BarcodeYear"
                          />
                        </div>
                      </div>

                      <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                        <div class="form-group mb-3">
                          <label class="mb-1">ราคา(สินค้า):</label>
                          <treeselect 
                            id="UnitPrice"
                            v-model="UnitPrice"
                            :multiple="true"
                            :options="UnitPriceOptions"
                            placeholder="กรุณาเลือก"
                            ref="UnitPrice"
                          />
                        </div>
                      </div>

                      <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                        <div class="form-group mb-3">
                          <label class="mb-1">ช่วงคงค้าง:</label>
                          <treeselect 
                            id="PeriodRange"
                            v-model="PeriodRange"
                            :multiple="true"
                            :options="PeriodRangeOptions"
                            placeholder="กรุณาเลือก"
                            ref="PeriodRange"
                          />
                        </div>
                      </div>

                      <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                        <div class="form-group mb-3">
                          <label class="mb-1">ปีคงค้าง:</label>
                          <treeselect 
                            id="PeriodYear"
                            v-model="PeriodYear"
                            :multiple="true"
                            :options="PeriodYearOptions"
                            placeholder="กรุณาเลือก"
                            ref="PeriodYear"
                          />
                        </div>
                      </div>

                      <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                        <div class="form-group mb-3">
                          <label class="mb-1">หมุนเวียน/ไม่หมุนเวียน:</label>
                          <treeselect 
                            id="Circulate"
                            v-model="Circulate"
                            :multiple="true"
                            :options="CirculateOptions"
                            placeholder="กรุณาเลือก"
                            ref="Circulate"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </Collapsible>
              </div>
              <!--End : Collap ค้นหาสินค้า-->

              <!--Begin : Collap ค้นหาผู้ถือครอง-->
              <div class="col-xl-12 col-lg-12 col-md-12 .col-sm-12 col-xs-12 mt-3">
                <Collapsible class="product-collapsible">
                  <div slot="trigger">
                    <div class="customTrigger">
                      <div class="kt-portlet__head-label">
                        <h5 class="kt-portlet__head-title text-primary">
                          <i class="la la-minus-square"></i> ค้นหาผู้ถือครอง
                        </h5>
                      </div>
                    </div>
                  </div>

                  <div slot="closedTrigger">
                    <div class="customTrigger">
                      <div class="kt-portlet__head-label">
                        <h5 class="kt-portlet__head-title text-primary">
                          <i class="la	la-plus-square"></i> ค้นหาผู้ถือครอง
                        </h5>
                      </div>
                    </div>
                  </div>

                  <div id="product">
                    <div class="row">
                      <div v-if="this.$root.canShow(['BR_REPORT'])" class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                        <div class="form-group mb-3">
                          <label class="mb-1">เจ้าของทรัพย์สิน:</label>
                          <treeselect
                            v-model="AssetOwnerId"
                            :multiple="true"
                            :options="AssetOwnerOptions"
                            :clear-on-select="true"
                            placeholder="กรุณาเลือก"
                          />
                        </div>
                      </div>
                      <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                        <div class="form-group mb-3">
                          <label class="mb-1">ประเภทคงค้าง:</label>
                          <treeselect
                            v-model="OwnerType"
                            :multiple="true"
                            :options="OwnerTypeOptions"
                            :clear-on-select="true"
                            placeholder="กรุณาเลือก"
                          />
                        </div>
                      </div>
  
                      <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                        <div class="form-group mb-3">
                          <label class="mb-1">ตัวแทนจำหน่าย(Group):</label>
                          <treeselect
                            v-model="HeadAgentCode"
                            :multiple="true"
                            :options="HeadAgentCodeOptions"
                            :clear-on-select="true"
                            placeholder="กรุณาเลือก"
                          />
                        </div>
                      </div>

                      <div v-if="!this.$root.canShow(['super_admin']) && this.$root.canShow(['AGENT_REPORT'])" 
                        class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                        <div class="form-group mb-3">
                          <label class="mb-1">ประเภทร้านค้า:</label>
                          <treeselect
                            v-model="reBShopTypeId"
                            :multiple="true"
                            :options="reBShopTypeIdOptions"
                            :clear-on-select="true"
                            placeholder="กรุณาเลือก"
                          />
                        </div>
                      </div>
                    </div>

                    <div class="row">
                        <div v-if="this.$root.canShow(['BR_REPORT'])"
                             class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                            <div class="form-group mb-3">
                                <label class="mb-1">ผู้ถือครอง(คลังสินค้า):</label>
                                <treeselect v-model="reBCurrentLocationPlant"
                                            :multiple="true"
                                            :options="reBCurrentLocationPlantOptions"
                                            :clear-on-select="true"
                                            placeholder="กรุณาเลือก" />
                            </div>
                        </div>

                        <div v-if="this.$root.canShow(['AGENT_REPORT'])"
                             class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                            <div class="form-group mb-3">
                                <label class="mb-1">ผู้ถือครอง(ตัวแทนจำหน่าย):</label>
                                <treeselect id="reBCurrentLocationAgent"
                                            v-model="reBCurrentLocationAgent"
                                            :multiple="true"
                                            :options="reBCurrentLocationAgentOptions"
                                            :clear-on-select="true"
                                            v-on:select="AgentClearAfterselect"
                                            v-on:deselect="AgentClearAfterselect"
                                            placeholder="กรุณาเลือก" />
                            </div>
                        </div>

                        <div v-if="
                          this.$root.canShow([
                            'AGENT_REPORT',
                            'SUB_AGENT_REPORT',
                          ])
                        "
                             class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                            <div class="form-group mb-3">
                                <label class="mb-1">ผู้ถือครอง(ตัวแทนจำหน่ายย่อย):</label>
                                <treeselect id="reBCurrentLocationSubAgent"
                                            v-model="reBCurrentLocationSubAgent"
                                            :multiple="true"
                                            :load-options="LoadreBCurrentLocationSubAgentOptions"
                                            v-on:open="reLoadreBCurrentLocationSubAgentOptions"
                                            :async="true"
                                            v-on:select="SubAgentClearAfterselect"
                                            searchPromptText="กรุณาพิมพ์คำที่ต้องการค้นหา"
                                            placeholder="กรุณาเลือก"
                                            :cacheOptions="false"
                                            ref="reBCurrentLocationSubAgent" />
                            </div>
                        </div>

                        <div v-if="this.$root.canShow(['AGENT_REPORT'])"
                             class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                            <div class="form-group mb-3">
                                <label class="mb-1">ผู้ถือครอง(ร้านค้า):</label>
                                <treeselect id="reBCurrentLocationShop"
                                            v-model="reBCurrentLocationShop"
                                            :multiple="true"
                                            :load-options="LoadreBCurrentLocationShopOptions"
                                            v-on:open="reLoadreBCurrentLocationShopOptions"
                                            :async="true"
                                            v-on:select="ShopClearAfterselect"
                                            searchPromptText="กรุณาพิมพ์คำที่ต้องการค้นหา"
                                            placeholder="กรุณาเลือก"
                                            :cacheOptions="false"
                                            ref="reBCurrentLocationShop" />
                            </div>
                        </div>

                        <div v-if="
                          this.$root.canShow([
                            'AGENT_REPORT',
                            'SUB_AGENT_REPORT',
                          ])
                        "
                             class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                            <div class="form-group mb-3">
                                <label class="mb-1">ผู้ถือครอง(ร้านค้าตัวแทนย่อย):</label>
                                <treeselect id="reBCurrentLocationSubShop"
                                            v-model="reBCurrentLocationSubShop"
                                            :multiple="true"
                                            :load-options="LoadreBCurrentLocationSubShopOptions"
                                            v-on:open="reLoadreBCurrentLocationSubShopOptions"
                                            :async="true"
                                            v-on:select="ClearAfterselect"
                                            searchPromptText="กรุณาพิมพ์คำที่ต้องการค้นหา"
                                            placeholder="กรุณาเลือก"
                                            :cacheOptions="false"
                                            ref="reBCurrentLocationSubShop" />
                            </div>
                        </div>

                        <div v-if="this.$root.canShow(['BR_REPORT'])"
                             class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                            <div class="form-group mb-3">
                                <label class="mb-1">ผู้ถือครอง(ซัพพลายเออร์):</label>
                                <treeselect v-model="reBCurrentLocationVendor"
                                            :multiple="true"
                                            :load-options="LoadreBCurrentLocationVendorOptions"
                                            v-on:open="reLoadreBCurrentLocationVendorOptions"
                                            :async="true"
                                            v-on:select="ClearAfterselect"
                                            searchPromptText="กรุณาพิมพ์คำที่ต้องการค้นหา"
                                            placeholder="กรุณาเลือก"
                                            :cacheOptions="true"
                                            ref="reBCurrentLocationVendor" />
                            </div>
                        </div>

                        <div v-if="this.$root.canShow([''])"
                             class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                            <div class="form-group mb-3">
                                <label class="mb-1">ประเภทผู้ถือครอง:</label>
                                <treeselect id="reBCurrentLocationType"
                                            v-model="reBCurrentLocationType"
                                            :options="reBCurrentLocationTypeOptions"
                                            placeholder="กรุณาเลือก"
                                            ref="reBCurrentLocationType" />
                            </div>
                        </div>

                        <div v-if="this.$root.canShow([''])" class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                        </div>

                        <div v-if="this.$root.canShow([''])"
                             class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                            <div class="form-group mb-3">
                                <label class="mb-1">เขตการขาย(ผู้ถือครอง):</label>
                                <treeselect id="reBDepartment"
                                            v-model="reBDepartment"
                                            :multiple="true"
                                            :options="reBDepartmentOptions"
                                            placeholder="กรุณาเลือก"
                                            ref="reBDepartment" />
                            </div>
                        </div>

                        <div v-if="this.$root.canShow([''])"
                             class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                            <div class="form-group mb-3">
                                <label class="mb-1">จังหวัด(ผู้ถือครอง):</label>
                                <treeselect v-model="reBProvince"
                                            :multiple="true"
                                            :options="reBProvinceOptions"
                                            :clear-on-select="true"
                                            placeholder="กรุณาเลือก" />
                            </div>
                        </div>

                        <div v-if="this.$root.canShow(['BR_REPORT','SUB_AGENT_REPORT'])" class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                            <div class="form-group mb-3">
                                <label class="mb-1">ประเภทร้านค้า:</label>
                                <treeselect v-model="reBShopTypeId"
                                            :multiple="true"
                                            :options="reBShopTypeIdOptions"
                                            :clear-on-select="true"
                                            placeholder="กรุณาเลือก" />
                            </div>
                        </div>
                    </div>
                  </div>
                </Collapsible>
              </div>
              <!--End : Collap ค้นหาผู้ถือครอง-->
            </div>

            <div class="row mb-3 mt-3">
              <div
                class="col-xl-6"
                v-if="
                  this.$root.canShow([
                    'AGENT_REPORT',
                    'SUB_AGENT_REPORT',
                    'BR_REPORT',
                  ])
                "
              >
                <button
                  class="btn btn-outline-primary"
                  @click="exportBarcodes"
                  type="submit"
                >
                  <span>
                    <i class="fas fa-file-export"></i><span>Export Excel</span>
                  </span>
                </button>
                <button
                  type="reset"
                  class="btn btn-secondary"
                  @click="formReset"
                >
                  ล้างค่าทั้งหมด
                </button>
              </div>
            </div>
          </form>
          <!-- end: Search Form -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import router from "../../router";
import select2 from "../../Shared/Select2";
import axios from "axios";
//import "vue-collapsible-component/lib/vue-collapsible.css";
import Collapsible from "../../Shared/Collapsible"; //"vue-collapsible-component";
// import the component
import Treeselect from "@riophae/vue-treeselect";
// import the styles
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import { ASYNC_SEARCH } from "@riophae/vue-treeselect";

require("sweetalert2");

export default {
  components: {
    select2,
    Collapsible,
    Treeselect,
  },
  data: function() {
    var self = this;

    return {
      UsersId : [],
      MbIsShowCancel : false ,
      // CR 02/09/2026 — filter "สถานะใช้งาน" (1=ใช้งาน เป็นค่าเริ่มต้น, 0=ปิดใช้งาน, null=ทั้งหมด)
      ActiveStatus: 1,
      ActiveStatusOptions: [
        { id: 1, label: "ใช้งาน" },
        { id: 0, label: "ปิดใช้งาน" },
      ],
      // CR 02/09/2026 ข้อ 4 — filter "สถานะทรัพย์สินเช่า" (null=ทั้งหมด เป็นค่าเริ่มต้น)
      IsLeasedAssets: null,
      LeasedAssetsOptions: [
        { id: 0, label: "ทรัพย์สินบริษัท" },
        { id: 1, label: "ทรัพย์สินเช่า" },
      ],
      ActiveStatusInfoText:
        'ใช้งาน = ไม่แสดงข้อมูล BARCODE ที่ คอลัมน์ "ผู้ดูแลทรัพย์สิน" 1.Z000002 คลัง Writeoff(ตัวแทนจำหน่าย), 2.คลังสินค้าที่ตั้งค่า "ประเภทคลังสินค้า = คลัง(จัดการข้อมูล)"<br/>*กำหนดเป็นค่าเริ่มต้น<br/>ปิดใช้งาน = แสดงข้อมูล BARCODE ที่ คอลัมน์ "ผู้ดูแลทรัพย์สิน" 1.Z000002 คลัง Writeoff(ตัวแทนจำหน่าย), 2.คลังสินค้าที่ตั้งค่า "ประเภทคลังสินค้า = คลัง(จัดการข้อมูล)"',
      MbBarcodeStautsDisabled : false ,
      reBBarcodeStatusCode: [],
      reBBarcode: null,
      reBDepartmentMaterialCode: [],
      reBProductTypeId: [],
      reBBrandId: [],
      reBAssetCode: [],
      reBCurrentLocationPlant: [],
      reBCurrentLocationAgent: [],
      reBCurrentLocationSubAgent: [],
      reBCurrentLocationShop: [],
      reBCurrentLocationSubShop: [],
      reBCurrentLocationVendor: [],
      reBCurrentLocationType: null,
      reBDepartment: [],
      reBProvince: [],
      reBShopTypeId: [],
      //reBHostAgentCode: null,
      reBHostAgentCode: [],
      reBTransitId: null,
      reBOnHoldDays: null,
      reBBarcodeStatusCodeOptions: [],

      ProductIdBrand: [],
      ProductIdBrandOptions: [],
      fullProductData: [],

      BarcodeYear: [],
      BarcodeYearOptions: [],
      AllBarcodeYearOptions: [],

      UnitPrice: [],
      UnitPriceOptions: [],

      PeriodRange: [],
      PeriodRangeOptions: [],

      PeriodYear: [],
      PeriodYearOptions: [],

      Circulate: [],
      CirculateOptions: [],

      AssetOwnerId: [],
      AssetOwnerOptions: [],

      OwnerType: [],
      OwnerTypeOptions: [],

      HeadAgentCode: [],
      HeadAgentCodeOptions: [],

      reBBarcodeOptions: {
        minimumResultsForSearch: -1,
        placeholder: "กรุณาเลือกBarcode",
        allowClear: true,
        ajax: {
          url: "/Api/Barcode/Select2BarcodeAll",
          data: function(params) {
            var query = {
              search: params.term,
              page: params.page || 1,
            };
            return query;
          },
          processResults: function(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more,
              },
            };
          },
          transport: function(params, success, failure) {
            params.beforeSend = function(request) {
              request.setRequestHeader(
                "Authorization",
                "Bearer " + self.$root.user.access_token
              );
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          },
        },
      },
      reBDepartmentMaterialCodeOptions: [],
      reBNFCCodeOptions: [],
      reBProductTypeIdOptions: [],
      reBBrandIdOptions: [],
      reBAssetCodeOptions: [],
      reBCurrentLocationPlantOptions: [],
      reBCurrentLocationAgentOptions: [],
      reBCurrentLocationSubAgentOptions: [],
      reBCurrentLocationShopOptions: [],
      reBCurrentLocationSubShopOptions: [],
      // reBCurrentLocationSubShopOptions: {
      //   placeholder: "กรุณาเลือกผู้ถือครอง(ร้านค้าตัวแทนย่อย)",
      //   allowClear: true,
      //   ajax: {
      //     url: "/Api/Shop/SubShopOption",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         page: params.page || 1,
      //       };
      //       return query;
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      // },
      reBCurrentLocationVendorOptions: [],
      reBCurrentLocationTypeOptions: [],
      reBDepartmentOptions: [],
      reBProvinceOptions: [],
      reBShopTypeIdOptions: [],
      reBHostAgentCodeOptions: [],
      reBTransitIdOptions: {
        placeholder: "กรุณาเลือกขนส่ง",
        allowClear: true,
        ajax: {
          url: "/Api/Transport/Select2Transport",
          type: "post",
          dataType: "json",
          contentType: "application/json",
          data: function(params) {
            var query = {
              showVendorTransport: true,
              agentCodes: [],
              search: params.term,
              page: params.page || 1,
            };
            return JSON.stringify(query);
          },
          processResults: function(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more,
              },
            };
          },
          transport: function(params, success, failure) {
            params.beforeSend = function(request) {
              request.setRequestHeader(
                "Authorization",
                "Bearer " + self.$root.user.access_token
              );
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          },
        },
        },

        OdCurrentLocationSubAgentOptions: []

    };
  },
  computed: {
    // CR 02/09/2026 — ไม่แสดง filter "สถานะใช้งาน" ให้สิทธิ์ แอดมินตัวแทนจำหน่าย / แอดมินตัวแทนจำหน่ายย่อย
    // (super_admin เห็นเสมอ — canShow คืน true ให้ super_admin ทุกกรณี จึงต้องใช้ canShowExSuperAdmin)
    showActiveStatusFilter() {
      return (
        this.$root.canShow(["super_admin"]) ||
        !this.$root.canShowExSuperAdmin(["AGENT_REPORT", "SUB_AGENT_REPORT"])
      );
    },
    filteredProductIdBrandOptions() {
      if (!this.reBBrandId.length)
      {
        return this.ProductIdBrandOptions;
      }
      let filteredOptions = [];
      this.fullProductData.forEach(item => {
        if (this.reBBrandId.map(Number).includes(item.data.productBrandId)) {
          filteredOptions.push({
            id: item.id,
            label: item.text,
            productBrandId: item.data.productBrandId,
          });
        }
      });
      return filteredOptions;
      },
      showDDLAgentName() {
          let userRoles = this.$root.user.profile.role;
          const hasBr = userRoles.includes("BR_REPORT");
          const hasAgent = userRoles.includes("AGENT_REPORT");
          const hasSubAgent = userRoles.includes("SUB_AGENT_REPORT");

          if (hasSubAgent) { 
            if (hasAgent || hasBr)
                return true; /* หากเป็นตัวแทนย่อย และเป็นตัวแทนหรือกลุ่มbr ก็จะยังแสดง filter */
            else
                  return false; /* หากเป็นตัวแทนย่อยอย่างเดียวจะ return false */
          }
          return true;
      },
  },
  methods: {
    clickcheckbox: function(e) {
      
      let self = this;
         setTimeout(function () {
             if(self.MbIsShowCancel){ 
                self.MbBarcodeStautsDisabled = true ;
                self.reBBarcodeStatusCode = []; 
              }
              else{
                self.MbBarcodeStautsDisabled = false ;
              }
              
            }, 100);
     
      //self.$parent.saveSummit(this.data.headerId);
    },
    formReset: function(e) {
      let self = this;

      self.UsersId = [] ;
      self.reBBarcodeStatusCode = [];
      self.reBBarcode = null;
      self.reBDepartmentMaterialCode = [];
      self.reBProductTypeId = [];
      self.reBBrandId = [];
      self.reBAssetCode = [];
      self.reBCurrentLocationPlant = [];
      self.reBCurrentLocationAgent = [];
      self.reBCurrentLocationSubAgent = [];
      self.reBCurrentLocationShop = [];
      self.reBCurrentLocationSubShop = [];
      self.reBCurrentLocationVendor = [];
      self.reBCurrentLocationType = null;
      self.reBDepartment = [];
      self.reBProvince = [];
      self.reBShopTypeId = [];
      self.reBHostAgentCode = [];
      self.reBTransitId = null;
      self.reBOnHoldDays = null;
      self.ProductIdBrand = [];
      self.Circulate = [];
      self.BarcodeYear = [];
      self.UnitPrice = [];
      self.PeriodRange = [];
      self.PeriodYear = [];
      self.AssetOwnerId = [];
      self.OwnerType = [];
      self.HeadAgentCode = [];
      self.MbIsShowCancel = false ;
      self.ActiveStatus = 1; // CR 02/09/2026 — กลับไปที่ค่าเริ่มต้น "ใช้งาน"
      self.IsLeasedAssets = null; // CR 02/09/2026 ข้อ 4

      $("#reBBarcodeStatusCode")
        .val("")
        .trigger("change");

      $("#reBBarcode")
        .val("")
        .trigger("change");

      $("#reBDepartmentMaterialCode")
        .val("")
        .trigger("change");

      $("#reBProductTypeId")
        .val("")
        .trigger("change");

      $("#reBBrandId")
        .val("")
        .trigger("change");

      $("#reBAssetCode")
        .val("")
        .trigger("change");

      $("#reBCurrentLocationPlant")
        .val("")
        .trigger("change");

      $("#reBCurrentLocationAgent")
        .val("")
        .trigger("change");

      $("#reBCurrentLocationSubAgent")
        .val("")
        .trigger("change");

      $("#reBCurrentLocationShop")
        .val("")
        .trigger("change");

      $("#reBCurrentLocationSubShop")
        .val("")
        .trigger("change");

      $("#reBCurrentLocationVendor")
        .val("")
        .trigger("change");

      $("#reBCurrentLocationType")
        .val("")
        .trigger("change");

      $("#reBDepartment")
        .val("")
        .trigger("change");

      $("#reBProvince")
        .val("")
        .trigger("change");

      $("#reBShopTypeId")
        .val("")
        .trigger("change");

      $("#reBHostAgentCode")
        .val("")
        .trigger("change");

      $("#reBTransitId")
        .val("")
        .trigger("change");

      $("#ProductIdBrand").val("").trigger("change");
      $("#Circulate").val("").trigger("change");
      $("#BarcodeYear").val("").trigger("change");
      $("#UnitPrice").val("").trigger("change");
      $("#PeriodRange").val("").trigger("change");
      $("#PeriodYear").val("").trigger("change");
      $("#AssetOwnerId").val("").trigger("change");
      $("#OwnerType").val("").trigger("change");
      $("#HeadAgentCode").val("").trigger("change");
    },
    formSubmit: function(e) {
      let self = this;

      e.preventDefault();
      var table = $("#brandCountTable").DataTable();
      table.draw();
    },
    exportBarcodes: function(e) {
      e.preventDefault();
      let self = this;

      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังโหลดข้อมูล กรุณารอสักครู่...",
      });

      var curentShop = [];
      if (
        self.reBCurrentLocationSubAgent.length != 0 ||
        self.reBCurrentLocationShop.length
      ) {
        curentShop = self.reBCurrentLocationSubAgent.concat(
          self.reBCurrentLocationShop
        );
        // console.log(curentShop);
      }

      axios({
        method: "post",
        url: "/Api/Report/ExportBarcodes",
        responseType: "arraybuffer",
        data: {
          UserIds : self.UsersId ,
          BarcodeStatusCode: self.reBBarcodeStatusCode,
          Barcode: self.reBBarcode,
          DepartmentMaterialCode: self.reBDepartmentMaterialCode,
          ProductTypeId: self.reBProductTypeId,
          AssetCode: self.reBAssetCode,
          BrandId: self.reBBrandId,
          CurrentLocationPlant: self.reBCurrentLocationPlant,
          CurrentLocationAgent: self.reBCurrentLocationAgent,
          CurrentLocationShop: self.reBCurrentLocationShop ,
            //CurrentLocationShop: self.reBCurrentLocationSubAgent.concat(
            //    self.reBCurrentLocationShop
            //),
          CurrentLocationSubAgent: self.reBCurrentLocationSubAgent,
          CurrentLocationSubShop: self.reBCurrentLocationSubShop,
          CurrentLocationType: self.reBCurrentLocationType,
          CurrentLocationVendor: self.reBCurrentLocationVendor,

            //SalesAreaId: self.reBDepartment,
            SalesAreaIds: self.reBDepartment,

          Province: self.reBProvince,
          ShopTypeId: self.reBShopTypeId,
          HostAgentCode: self.reBHostAgentCode,
          TransitId: self.reBTransitId,
          OnHoldDays: self.reBOnHoldDays,
          ProductIdBrand: self.ProductIdBrand,
          BarcodeYear: self.BarcodeYear,
          UnitPrice: self.UnitPrice,
          PeriodRange: self.PeriodRange,
          PeriodYear: self.PeriodYear,
          Circulate: self.Circulate,
          AssetOwnerId: self.AssetOwnerId,
          OwnerType: self.OwnerType,
          HeadAgentCode: self.HeadAgentCode,
          IsShowCancel : self.MbIsShowCancel,
          ActiveStatus: self.showActiveStatusFilter ? self.ActiveStatus : null,
          // ข้อ 4: ส่งเฉพาะเมื่อเป็นผู้ดูแลระบบ (role อื่นไม่เห็น filter นี้)
          IsLeasedAssets: self.$root.canShow(['super_admin']) ? self.IsLeasedAssets : null
        },
      })
        .then(function(response) {
          if (response.status == "200") {
            let filename = "";
            let contentType = response.headers["content-type"];
            let disposition = response.headers["content-disposition"];
            // console.log(disposition);
            //===Get Filename===
            if (disposition && disposition.indexOf("attachment") !== -1) {
              var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
              var matches = filenameRegex.exec(disposition);
              // console.log(matches);
              if (matches != null && matches[1]) {
                // console.log(matches);
                filename = matches[1].replace(/['"]/g, "");
              }
            }
            //Save file
            let blob = new Blob([response.data], { type: contentType });
            let link = document.createElement("a");
            link.href = window.URL.createObjectURL(blob);
            link.download = decodeURIComponent(filename);
            link.click();
          } else if (response.status == "204") {
            Swal.fire(
              "ไม่พบข้อมูล",
              "ไม่พบข้อมูลตามเงื่อนไขที่เลือก",
              "warning"
            );
          }
        })
        .catch(function(error) {
          Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
        })
        .then(function() {
          //self.formReset();
          KTApp.unblockPage();
        });
    },
    LoadreBBarcodeStatusCodeOptions: function(e) {
      var self = this;
      axios
        .get("/Api/Variables/Options?search=PRODUCT_BARCODE_STATUS", {
          params: {
            page: 1,
            all: true,
          },
        })
        .then(function(response) {
          if (response.status == 200) {
            var data = response.data.results;
            data.forEach((element) => {
              self.reBBarcodeStatusCodeOptions.push({
                id: element.id,
                label: element.text,
              });
            });
          }
        })
        .catch(function(error) {});
    },
    LoadreBDepartmentMaterialCodeOptions({ action, searchQuery, callback }) {
      var self = this;
      self.reBDepartmentMaterialCodeOptions = [];
      if (action === ASYNC_SEARCH) {
        axios
          .get("/Api/Barcode/Select2DepartmentMaterial", {
            params: {
              page: 1,
              all: true,
              search: searchQuery,
            },
          })
          .then(function(response) {
            if (response.status == 200) {
              var data = response.data.results;
              self.reBDepartmentMaterialCodeOptions = [];
              data.forEach((element) => {
                self.reBDepartmentMaterialCodeOptions.push({
                  id: element.id,
                  label: element.text,
                });
              });
            }
            callback(null, self.reBDepartmentMaterialCodeOptions);
          })
          .catch(function(error) {});
      }
    },
    LoadreBNFCCodeOptions({ action, searchQuery, callback }) {
      var self = this;
      self.reBNFCCodeOptions = [];
      if (action === ASYNC_SEARCH) {
        axios
          .get("/Api/Barcode/Select2NFC", {
            params: {
              page: 1,
              all: true,
              search: searchQuery,
            },
          })
          .then(function(response) {
            if (response.status == 200) {
              var data = response.data.results;
              self.reBNFCCodeOptions = [];
              data.forEach((element) => {
                self.reBNFCCodeOptions.push({
                  id: element.id,
                  label: element.text,
                });
              });
            }
            callback(null, self.reBNFCCodeOptions);
          });
      }
    },
    LoadreBProductTypeIdOptions: function(e) {
      var self = this;
      axios
        .get("/Api/ProductType/Select2ProductType", {
          params: {
            page: 1,
            all: true,
          },
        })
        .then(function(response) {
          if (response.status == 200) {
            var data = response.data.results;
            data.forEach((element) => {
              self.reBProductTypeIdOptions.push({
                id: element.id,
                label: element.text,
              });
            });
          }
        })
        .catch(function(error) {});
    },
    LoadreBBrandIdOptions: function(e) {
      var self = this;
      axios
        .get("/Api/ProductBrand/Select2SearchBrandExistProduct", {
          params: {
            page: 1,
            all: true,
          },
        })
        .then(function(response) {
          if (response.status == 200) {
            var data = response.data.results;
            data.forEach((element) => {
              self.reBBrandIdOptions.push({
                id: element.id,
                label: element.text,
              });
            });
          }
        })
        .catch(function(error) {});
    },
    LoadreBAssetCodeOptions: function(e) {
      var self = this;
      axios
        .get("/Api/Product/Select2Product", {
          params: {
            page: 1,
            all: true,
            excludeProductGroupId : 14
          },
        })
        .then(function(response) {
          if (response.status == 200) {
            var data = response.data.results;
            data.forEach((element) => {
              self.reBAssetCodeOptions.push({
                id: element.id,
                label: element.text,
              });
            });
          }
        })
        .catch(function(error) {});
    },
    LoadUsersIdOptions({ action, searchQuery, callback }){
      if (action === ASYNC_SEARCH) {
        axios
          .post("/Api/Report/User/Options",{ 
            page: 1,
            search: searchQuery,
            all: true,
          })
          .then(function(response) {
            if (response.status == 200) {
              var data = response.data.results;
              var result = [];
              data.forEach((element) => {
                result.push({
                  id: element.id,
                  label: element.text,
                });
              });
            }
            callback(null, result);
          })
          .catch(function(error) {});
      }
    },
    reLoadUsersIdOptions: function(){
      this.$refs.UsersId.trigger.searchQuery = null;
    },
    LoadreBCurrentLocationPlantOptions: function(e) {
      var self = this;
      axios
        .post("/Api/Plant/Select2Plant", {
          page: 1,
          all: true,
        })
        .then(function(response) {
          if (response.status == 200) {
            var data = response.data.results;
            data.forEach((element) => {
              self.reBCurrentLocationPlantOptions.push({
                id: element.id,
                label: element.text,
              });
            });
          }
        })
        .catch(function(error) {});
      },
      /***** ddl Agent *****/
      LoadHeadAgentCodeOptions: function(e) {
      var self = this;
      axios
        .post(
          "/Api/Report/Select2Agent?companyType=COMPANY_PROFILE_TYPE_AGENT",
          {
            province_id: [],
            department: self.rePMRegion,
            AgentCodes: [],
            page: 1,
          }
        )
        .then(function(response) {
          if (response.status == 200) {
            var data = response.data.results;
            self.reBCurrentLocationAgentOptions = [];

            if (data.length > 1) self.reBCurrentLocationAgentOptions = [{ id: "0", label: "ทั้งหมด" }];

            data.forEach((element) => {
              self.reBCurrentLocationAgentOptions.push({
                id: element.id,
                label: element.text,
              });
              self.HeadAgentCodeOptions.push({
                id: element.id,
                label: element.text,
              });
            });
          }
        })
        .catch(function(error) {});
      },

      
      reLoadreBCurrentLocationSubAgentOptions: function () {
          this.$refs.reBCurrentLocationSubAgent.trigger.searchQuery = null;
      },
      /***** ddl SubAgent *****/
      LoadreBCurrentLocationSubAgentOptions({ action, searchQuery, callback }) {
        var self = this;
        self.reBCurrentLocationSubAgentOptions = [];

        let reBCurrentLocationAgentTEMP = self.reBCurrentLocationAgent;
        let reBCurrentLocationShopTEMP = self.reBCurrentLocationShop;

        if (reBCurrentLocationAgentTEMP != null && reBCurrentLocationAgentTEMP.length == 1 && reBCurrentLocationAgentTEMP[0] == '0') {
            reBCurrentLocationAgentTEMP = []; // If item == 'ทั้งหมด' then set null for SubAgent
        }
        if (reBCurrentLocationShopTEMP != null && reBCurrentLocationShopTEMP.length == 1 && reBCurrentLocationShopTEMP[0] == '0') {
            reBCurrentLocationShopTEMP = []; // If item == 'ทั้งหมด' then set null for SubAgent
        }

        if (action === ASYNC_SEARCH) {
            axios
                .post("/Api/Report/Select2SubShopAgent", {
                    page: 1,
                    onlySubAgent: true,
                    all: true,
                    search: searchQuery,
                    agentCodes: reBCurrentLocationAgentTEMP,    // self.reBCurrentLocationAgent
                    shopCodes: reBCurrentLocationShopTEMP       //self.reBCurrentLocationShop
                })
                .then(function (response) {
                    if (response.status == 200) {
                        var data = response.data.results;
                        self.reBCurrentLocationSubAgentOptions = [];

                        if (data.length > 1) self.reBCurrentLocationSubAgentOptions = [{ id: "0", label: "ทั้งหมด" }];

                        data.forEach((element) => {
                            self.reBCurrentLocationSubAgentOptions.push({
                                id: element.id,
                                label: element.text,
                            });
                        });
                    }
                    callback(null, self.reBCurrentLocationSubAgentOptions);
                });
        }
      },

      reLoadreBCurrentLocationShopOptions: function () {
          this.$refs.reBCurrentLocationShop.trigger.searchQuery = null;
      },
      /***** ddl Shop *****/
      LoadreBCurrentLocationShopOptions({ action, searchQuery, callback }) {
          var self = this;

          let reBCurrentLocationAgentTEMP = self.reBCurrentLocationAgent;
          let reBCurrentLocationSubAgentTEMP = self.reBCurrentLocationSubAgent;

          if (reBCurrentLocationAgentTEMP != null && reBCurrentLocationAgentTEMP.length == 1 && reBCurrentLocationAgentTEMP[0] == '0') {
              reBCurrentLocationAgentTEMP = []; // If item == 'ทั้งหมด' then set null for SubAgent
          }
          if (reBCurrentLocationSubAgentTEMP != null && reBCurrentLocationSubAgentTEMP.length == 1 && reBCurrentLocationSubAgentTEMP[0] == '0') {
              reBCurrentLocationSubAgentTEMP = []; // If item == 'ทั้งหมด' then set null for SubAgent
          }

          self.reBCurrentLocationShopOptions = [];
          if (action === ASYNC_SEARCH) {
              axios
                  .post("/Api/Shop/Select2ShopByAgentAlerReport", {
                      page: 1,
                      all: true,
                      agentCodes: reBCurrentLocationAgentTEMP , //self.reBCurrentLocationAgent,
                      customerCode: reBCurrentLocationSubAgentTEMP,
                      search: searchQuery
                  })
                  .then(function (response) {
                      if (response.status == 200) {
                          var data = response.data.results;
                          self.reBCurrentLocationShopOptions = [];

                          if (data.length > 1) self.reBCurrentLocationShopOptions = [{ id: "0", label: "ทั้งหมด" }];

                          data.forEach((element) => {
                              self.reBCurrentLocationShopOptions.push({
                                  id: element.id,
                                  label: element.text,
                              });
                          });
                      }
                      callback(null, self.reBCurrentLocationShopOptions);
                  });
          }
      },

      reLoadreBCurrentLocationSubShopOptions: function () {
          this.$refs.reBCurrentLocationSubShop.trigger.searchQuery = null;
      },

      /***** ddl SubShop *****/
      LoadreBCurrentLocationSubShopOptions({ action, searchQuery, callback }) {
          var self = this;
          self.reBCurrentLocationSubShopOptions = [];

          let reBCurrentLocationAgentTEMP = self.reBCurrentLocationAgent;
          let reBCurrentLocationSubAgentTEMP = self.reBCurrentLocationSubAgent;
          let reBCurrentLocationShopTEMP = self.reBCurrentLocationShop;

          if (reBCurrentLocationAgentTEMP != null && reBCurrentLocationAgentTEMP.length == 1 && reBCurrentLocationAgentTEMP[0] == '0') {
              reBCurrentLocationAgentTEMP = []; // If item == 'ทั้งหมด' then set null for SubAgent
          }
          if (reBCurrentLocationSubAgentTEMP != null && reBCurrentLocationSubAgentTEMP.length == 1 && reBCurrentLocationSubAgentTEMP[0] == '0') {
              reBCurrentLocationSubAgentTEMP = []; // If item == 'ทั้งหมด' then set null for SubAgent
          }
          if (reBCurrentLocationShopTEMP != null && reBCurrentLocationShopTEMP.length == 1 && reBCurrentLocationShopTEMP[0] == '0') {
              reBCurrentLocationShopTEMP = []; // If item == 'ทั้งหมด' then set null for SubAgent
          }
          
          var allShops = [];

          if (self.reBCurrentLocationSubAgent != null && self.reBCurrentLocationSubAgent.length > 0 && reBCurrentLocationSubAgentTEMP.length > 0) {
              for (var i = 0, len = self.reBCurrentLocationSubAgent.length; i < len; ++i) {
                  allShops.push(self.reBCurrentLocationSubAgent[i]);
              }
          }
          if (self.reBCurrentLocationShop != null && self.reBCurrentLocationShop.length > 0 && reBCurrentLocationShopTEMP.length > 0) {
              for (var i = 0, len = self.reBCurrentLocationShop.length; i < len; ++i) {
                  allShops.push(self.reBCurrentLocationShop[i]);
              }
          }

          if (action === ASYNC_SEARCH) {
              axios
                  .post("/Api/Shop/SubShopOptionAlertReport", {
                      page: 1,
                      all: true,
                      search: searchQuery,
                      agentCodes: reBCurrentLocationAgentTEMP, //self.reBCurrentLocationAgent,
                      shopCodes: allShops,
                  })
                  .then(function (response) {
                      if (response.status == 200) {
                          var data = response.data.results;
                          self.reBCurrentLocationSubShopOptions = [];

                          if (data.length > 1) self.reBCurrentLocationSubShopOptions = [{ id: "0", label: "ทั้งหมด" }];

                          data.forEach((element) => {
                              self.reBCurrentLocationSubShopOptions.push({
                                  id: element.id,
                                  label: element.text,
                              });
                          });
                      }
                      callback(null, self.reBCurrentLocationSubShopOptions);
                  });
          }
      },

      AgentClearAfterselect: function () {
          let self = this;

          self.reBCurrentLocationSubAgent = [];
          self.reBCurrentLocationShop = [];
          self.reBCurrentLocationSubShop = [];

          $("#reBCurrentLocationSubAgent").val("").trigger("change");
          $("#reBCurrentLocationShop").val("").trigger("change");
          $("#reBCurrentLocationSubShop").val("").trigger("change");
          $(`[class="vue-treeselect__input"]`).val("");

      },

      SubAgentClearAfterselect: function () {
          let self = this;

          self.reBCurrentLocationShop = [];
          self.reBCurrentLocationSubShop = [];

          $("#reBCurrentLocationShop").val("").trigger("change");
          $("#reBCurrentLocationSubShop").val("").trigger("change");
          $(`[class="vue-treeselect__input"]`).val("");

      },

      ShopClearAfterselect: function () {
          let self = this;
          self.reBCurrentLocationSubShop = [];

          $("#reBCurrentLocationSubShop").val("").trigger("change");
          $(`[class="vue-treeselect__input"]`).val("");

      },

    /**** End Modify  *****/
    
    
    reLoadreBCurrentLocationVendorOptions: function(){
      this.$refs.reBCurrentLocationVendor.trigger.searchQuery = null;
    },
    LoadreBCurrentLocationVendorOptions({ action, searchQuery, callback }) {
      var self = this;
      self.reBCurrentLocationVendorOptions = [];
      if (action === ASYNC_SEARCH) {
        axios
          .get("/Api/Vendors/Select2Vendor", {
            params: {
              page: 1,
              all: true,
              search: searchQuery,
            },
          })
          .then(function(response) {
            if (response.status == 200) {
              var data = response.data.results;
              self.reBCurrentLocationVendorOptions = [];
              data.forEach((element) => {
                self.reBCurrentLocationVendorOptions.push({
                  id: element.id,
                  label: element.text,
                });
              });
            }
            callback(null, self.reBCurrentLocationVendorOptions);
          })
          .catch(function(error) {});
      }
    },
    LoadreBProvinceOptions: function(e) {
      var self = this;
      axios
        .post("/Api/Agents/Select2SearchProvince", {
          page: 1,
          all: true,
          department: [],
        })
        .then(function(response) {
          if (response.status == 200) {
            var data = response.data.results;
            data.forEach((element) => {
              self.reBProvinceOptions.push({
                id: element.id,
                label: element.text,
              });
            });
          }
        })
        .catch(function(error) {});
    },
    LoadreBShopTypeIdOptions: function(e) {
      var self = this;
      axios
        .get("/Api/ShopType/Select2SearchShopType", {
          params: {
            page: 1,
            all: true,
          },
        })
        .then(function(response) {
          if (response.status == 200) {
            var data = response.data.results;
            data.forEach((element) => {
              self.reBShopTypeIdOptions.push({
                id: element.id,
                label: element.text,
              });
            });
          }
        })
        .catch(function(error) {});
    },
    LoadreBHostAgentCodeOptions: function(e) {
      var self = this;
      axios
        .post("/Api/Report/Select2Agent", {
          province_id: [],
          department: [],
          AgentCodes: [],
          page: 1,
          all: true,
        })
        .then(function(response) {
          if (response.status == 200) {
            var data = response.data.results;
            self.reBHostAgentCodeOptions = [];
            data.forEach((element) => {
              self.reBHostAgentCodeOptions.push({
                id: element.id,
                label: element.text,
              });
            });
          }
        })
        .catch(function(error) {});
    },
    async loadProductData() {
      try {
        const response = await axios.post("/Api/product/Select2ProductReport", {
          page: 1,
          all: true,
          search: "",
          productGroupIds: [14],
        });
        if (response.status === 200) {
          this.fullProductData = response.data.results;
          this.ProductIdBrandOptions = this.fullProductData.map((item) => ({
            id: item.id,
            label: item.text,
            productBrandId: item.data.productBrandId,
          }));
        }
      } catch (error) {
        console.error("Error loading product data:", error);
      }
    },
    BrandIdClearAfterSelect: function(){
      this.ProductIdBrand = [];
    },
    BrandIdClearAfterDeSelect: function(){
      this.ProductIdBrand = []; 
    },
    reLoadBarcodeYearOptions: function(){
      this.$refs.BarcodeYear.trigger.searchQuery = null;
    },
    LoadBarcodeYearOptions({ action, searchQuery, callback }){
      if (this.AllBarcodeYearOptions.length === 0) {
        axios
          .get("/Api/Report/Select2BarcodeYear", {
            params: {
              page: 1,
              all: true,
            },
          })
          .then((response) => {
            if (response.status === 200) {
              this.AllBarcodeYearOptions = response.data.results.map((element) => ({
                id: element.id,
                label: element.text,
              }));
              callback(null, this.AllBarcodeYearOptions);
            }
          })
          .catch((error) => {
            callback(error, []);
          });
      } else {
        const query = searchQuery ? searchQuery.toLowerCase() : "";
        const filteredOptions = this.AllBarcodeYearOptions.filter((option) =>
          option.label.toLowerCase().includes(query)
        );
        callback(null, filteredOptions);
      }
    },
    LoadUnitPriceOptions: function(e) {
      var self = this;
      axios
        .get("/Api/Report/Select2ProductUnitPrice", {
          params: {
            page: 1,
            all: true,
          },
        })
        .then(function(response) {
          if (response.status == 200) {
            var data = response.data.results;
            data.forEach((element) => {
              self.UnitPriceOptions.push({
                id: element.id,
                label: element.text,
              });
            });
          }
        })
        .catch(function(error) {});
    },
    LoadOdPeriodOptions() {
      var self = this;
      axios
        .get("/Api/ReportOverdue/Select2PeriodOption", {
          params: {
            page: 1,
            all: true,
            PeriodRangeType : 2,
          },
        })
        .then(function(response) {
          if (response.status == 200) {
            var data = response.data.results;
            self.PeriodRangeOptions = [];
            data.forEach((element) => {
              self.PeriodRangeOptions.push({
                id: element.id,
                label: element.text,
              });
            });
          }
        })
        .catch(function(error) {});
    },
    LoadPeriodYearOptions: function (e) {
      var self = this;
      self.PeriodYearOptions = [];
      var currentYear = new Date().getFullYear();
      for (let year = 2021; year <= currentYear; year++) {
        self.PeriodYearOptions.push({
          id: year.toString(),
          label: year.toString(),
        });
      }
    },
    LoadCirculateOptions: function (e) {
      var self = this;
      self.CirculateOptions = [];
      var data = [
        {
          id: 1,
          text: "หมุนเวียน",
        },
        {
          id: 2,
          text: "ไม่หมุนเวียน",
        },
      ];
      data.forEach((element) => {
        self.CirculateOptions.push({
          id: element.id,
          label: element.text,
        });
      });
    },
    LoadAssetOwnerOptions: function(e) {
      var self = this;
      axios
        .get("/Api/assetOwner/Select2SearchAssetOwner", {
          params: {
            page: 1,
            all: true,
          },
        })
        .then(function(response) {
          if (response.status == 200) {
            var data = response.data.results;
            data.forEach((element) => {
              self.AssetOwnerOptions.push({
                id: element.id,
                label: element.text,
              });
            });
          }
        })
        .catch(function(error) {});
    },
    LoadOwnerTypeOptions: function(e) {
      var self = this;
      axios
        .get("/Api/Variables/Options?search=MASTER_OWNER_TYPE", {
          params: {
            page: 1,
            all: true,
          },
        })
        .then(function(response) {
          if (response.status == 200) {
            var data = response.data.results;
            data.forEach((element) => {
              self.OwnerTypeOptions.push({
                id: element.id,
                label: element.text,
              });
            });
          }
        })
        .catch(function(error) {});
    },
    LoadCurrentLocationTypeOptions: function (e) {
      var self = this;
      self.reBCurrentLocationTypeOptions = [];
      var data = [
        { id: "คลัง/โรงงาน", text: "คลัง/โรงงาน" },
        { id: "ตัวแทนจำหน่าย", text: "ตัวแทนจำหน่าย" },
        { id: "ตัวแทนจำหน่ายย่อย", text: "ตัวแทนจำหน่ายย่อย" },
        { id: "ร้านค้า", text: "ร้านค้า" },
        { id: "ร้านค้า (ตัวแทนฯย่อย)", text: "ร้านค้า (ตัวแทนฯย่อย)" },
        { id: "ซัพพลายเออร์", text: "ซัพพลายเออร์" },
      ];
      data.forEach((element) => {
        self.reBCurrentLocationTypeOptions.push({
          id: element.id,
          label: element.text,
        });
      });
    },
    LoadDepartmentOptions: function (e) {
      var self = this;
      axios
        .get("/Api/MasterSalesArea/FindOptions", {
          params: {
            page: 1,
            all: true,
          },
        })
        .then(function(response) {
          if (response.status == 200) {
            var data = response.data.results;
            data.forEach((element) => {
              self.reBDepartmentOptions.push({
                id: element.id,
                label: element.text,
              });
            });
          }
        })
        .catch(function(error) {});
    },
    ClearAfterselect: function(){
      $(`[class="vue-treeselect__input"]`).val("");
    }
  },
  async mounted() {

    
    let self = this;

    // CR 02/09/2026 — ปุ่ม Info ของ filter "สถานะใช้งาน"
    self.$nextTick(function () {
      if (self.$refs.ActiveStatusInfo) {
        $(self.$refs.ActiveStatusInfo).popover();
      }
    });

    self.LoadreBBarcodeStatusCodeOptions();
    self.LoadreBProductTypeIdOptions();
    self.LoadreBBrandIdOptions();
    self.LoadreBAssetCodeOptions();
    self.LoadreBCurrentLocationPlantOptions();
    self.LoadHeadAgentCodeOptions();
    //self.LoadreBCurrentLocationSubAgentOptions();
    self.LoadreBProvinceOptions();
    self.LoadreBShopTypeIdOptions();
    self.LoadreBHostAgentCodeOptions();
    self.loadProductData();
    self.LoadUnitPriceOptions();
    self.LoadOdPeriodOptions();
    self.LoadPeriodYearOptions();
    self.LoadCirculateOptions();
    self.LoadAssetOwnerOptions();
    self.LoadOwnerTypeOptions();
    self.LoadCurrentLocationTypeOptions();
    self.LoadDepartmentOptions();

    var arrows;
    if (KTUtil.isRTL()) {
      arrows = {
        leftArrow: '<i class="la la-angle-right"></i>',
        rightArrow: '<i class="la la-angle-left"></i>',
      };
    } else {
      arrows = {
        leftArrow: '<i class="la la-angle-left"></i>',
        rightArrow: '<i class="la la-angle-right"></i>',
      };
    }

    self.reBcDateReq = moment().format("DD/MM/YYYY h:mm a");

    $(self.$refs.reBc01).datepicker({
      autoclose: true,
      clearBtn: true,
      format: "dd/mm/yyyy",
      rtl: KTUtil.isRTL(),
      minDate: moment(), // Current day
      maxDate: moment().add(30, "days"), // 30 days from the current day
      orientation: "bottom left",
      todayBtn: "linked",
      todayHighlight: true,
      templates: arrows,
    });
    //self.reMmTransactionDateEnd = moment().endOf('month');
    $(self.$refs.reBc01)
      .datepicker(
        "update",
        !!self.reBc01 ? self.reBc01.format("DD/MM/YYYY") : null
      )
      .on("changeDate", function(e) {
        self.reBc01 = e.dates.length != 0 ? moment(e.date) : null;
      });

    $(self.$refs.reBc02).datepicker({
      autoclose: true,
      clearBtn: true,
      format: "dd/mm/yyyy",
      rtl: KTUtil.isRTL(),
      minDate: moment(), // Current day
      maxDate: moment().add(30, "days"), // 30 days from the current day
      orientation: "bottom left",
      todayBtn: "linked",
      todayHighlight: true,
      templates: arrows,
    });
    //self.reMmTransactionDateEnd = moment().endOf('month');
    $(self.$refs.reBc02)
      .datepicker(
        "update",
        !!self.reBc02 ? self.reBc02.format("DD/MM/YYYY") : null
      )
      .on("changeDate", function(e) {
        self.reBc02 = e.dates.length != 0 ? moment(e.date) : null;
      });

    $(self.$refs.reBc03).datepicker({
      autoclose: true,
      clearBtn: true,
      format: "dd/mm/yyyy",
      rtl: KTUtil.isRTL(),
      minDate: moment(), // Current day
      maxDate: moment().add(30, "days"), // 30 days from the current day
      orientation: "bottom left",
      todayBtn: "linked",
      todayHighlight: true,
      templates: arrows,
    });
    //self.reMmTransactionDateEnd = moment().endOf('month');
    $(self.$refs.reBc03)
      .datepicker(
        "update",
        !!self.reBc03 ? self.reBc03.format("DD/MM/YYYY") : null
      )
      .on("changeDate", function(e) {
        self.reBc03 = e.dates.length != 0 ? moment(e.date) : null;
      });

    $(this.$refs.form).validate().settings.ignore = ":hidden";
  },
};
</script>

<style lang="scss" scoped></style>


// WEBPACK FOOTER //
// App/Components/Report/Barcodes.vue